// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"EconomicCIframe_disclaimer__SC4H5","iframeContainer":"EconomicCIframe_iframeContainer__ZW_tF"};